module.exports = __webpack_public_path__ + "img/logo.67150929.png";